import React from "react";
import LoadingSvg from "../../assets/svg/LoadingSVG";
import CustomButtonProps from "../../services/models/customButtonProps.model";
import CustomText from "../atomic/CustomText";
import RequiredFieldTooltip from "../global/RequiredFieldTooltip";

function CustomButton({
  textInformation,
  Icon,
  loading,
  showTooltip,
  tooltipText,
  ...buttonProps
}: CustomButtonProps): JSX.Element {
  // Check if textInformation.text is a React element (icon SVG)
  const isTextIcon = React.isValidElement(textInformation.text);
  
  return (
    <RequiredFieldTooltip tooltipText={tooltipText} required={showTooltip} id={tooltipText}  {...buttonProps.tooltipProps}>
      <button
        {...buttonProps}
        className={`${buttonProps?.className ? buttonProps.className : ""}`}
      >
        {(Icon || loading || isTextIcon) && (
                <span className={`inline-flex items-center justify-center ${Icon || loading ? 'w-6 h-6 shrink-0' : ''}`}>
           {Icon && !loading && <Icon />}
            {isTextIcon && !loading && textInformation.text}
            {loading && (
              <LoadingSvg
                isSecondary
                stroke={buttonProps.loadingStroke}
                className="animate-spin"
              />
            )}
          </span>
        )}
        {!isTextIcon && (
          <CustomText
            text={textInformation.text}
            fontWeight={textInformation.fontWeight}
            fontSize={
              textInformation.fontSize ? textInformation.fontSize : "text-xs sm:text-sm"
            }
          />
        )}
      </button>
    </RequiredFieldTooltip>
  );
}

export default CustomButton;
